import { useCallback, useEffect, useState } from "react";
import { directorioMiembros, listar, listarReuniones, rpc, unir } from "../../services/datos";
import PanelProfesores from "../servidores/PanelProfesores";
import Esqueleto from "../../shared/components/Esqueleto";

// Programación de Mi Casa Kids (menú Mi Casa Kids): equipo de profesores y asistentes,
// quién sirve cada domingo y la rotación automática.
function ProgramacionKids() {
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");

  const cargar = useCallback(async () => {
    try {
      const [servicios, turnos, areas, miembros, vinculos] = await Promise.all([
        listarReuniones(), rpc("turnos_detalle"), listar("areas_servicio", { orden: "nombre" }),
        directorioMiembros(), listar("miembro_area"),
      ]);
      // Del equipo solo se muestran los nombres (del directorio), sin datos de contacto.
      const miembrosArea = unir(vinculos, "miembro_id", miembros, "miembros");
      setDatos({ servicios, turnos: turnos || [], areas, miembros, miembrosArea });
      setError("");
    } catch (e) {
      setError(e.message || "No se pudo cargar la programación de Mi Casa Kids.");
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="titulo-pagina">Programación de Mi Casa Kids</h2>
        <p className="text-gray-400 text-sm mt-1">Profesores y asistentes de cada domingo y la rotación automática.</p>
      </div>
      {error && <p role="alert" className="text-red-300 text-sm mb-4">{error}</p>}
      {!datos ? (
        !error && <Esqueleto texto="Cargando programación…" />
      ) : (
        <PanelProfesores {...datos} onCambio={cargar} />
      )}
    </div>
  );
}

export default ProgramacionKids;
